<div
	class="kt-header__topbar-item kt-header__topbar-item--quick-panel"
	style="margin: auto 4px; font-size: 20px; margin: 0 8px 0 8px"
	data-placement="bottom"
	ngbTooltip="Çıkış"
	(click)="logout()"
>
	<span class="kt-header__topbar-icon">
		<i *ngIf="!loader" class="fas fa-sign-out-alt"></i>
		<div *ngIf="loader" class="kt-spinner kt-spinner--sm kt-spinner--brand"></div>
	</span>
</div>
